export default __webpack_public_path__ + "static/media/14 WILDLIFE.d2a19c09.png";